import Cookies from "js-cookie";
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  return Cookies.get("accessToken1") ? children : <Navigate to="/" />;
};

export default PrivateRoute;
